module.exports = "https://dashboard.cdn.gifty.nl/6091/images/mailbox.png?77aac4ed8474eb74280bcbb69fe9650e";